<script>import MediaControls from '../MediaControls/MediaControls.svelte';
</script>

<MediaControls
  {...$$restProps}
  as="div"
  class="VideoPlayback {$$restProps.class || ''}"
  isPlaying={false}
  useAriaLabel={true}
/>

<style>:global(.VideoPlayback) {
  --media-controls-height: var(--video-playback-height);
  --media-controls-width: var(--video-playback-width);
  --media-controls-icon-play-height: var(--video-playback-icon-height);
  --media-controls-icon-play-width: var(--video-playback-icon-width);
}</style>
